import { MetricName } from '@canvas/frontend-metrics';

import { defineMetric, type MetricMetadataBase } from '../define-metric.ts';
import type { FrameState } from '../stabilized-scheduler.ts';

export const DATABASE_CELL_INLINE_EDITOR_OPEN_ATTR = 'data-database-cell-editor-open';

export function getCellInlineEditorOpenFrameState(
  tableRoot: HTMLElement,
  entryId: string,
  fieldId: string
): FrameState {
  const td = tableRoot.querySelector<HTMLElement>(
    `td[data-entry-id="${entryId}"][data-field-id="${fieldId}"]`
  );

  if (!td) {
    return { done: false, stabilityKey: null };
  }

  const marker = td.querySelector(`[${DATABASE_CELL_INLINE_EDITOR_OPEN_ATTR}]`);

  if (!marker) {
    return { done: false, stabilityKey: null };
  }

  return { done: true, stabilityKey: `${entryId}:${fieldId}` };
}

export interface CellInlineEditProbeData {
  tableRoot: HTMLElement | null;
  entryId: string;
  fieldId: string;
}

export type CellInlineEditMetadata = MetricMetadataBase;

export const cellInlineEditMetric = defineMetric<
  CellInlineEditProbeData,
  CellInlineEditMetadata
>({
  metricName: MetricName.DATABASE_CELL_INLINE_EDIT_OPEN_INTERACTION_TIME,
  buildProbe: (probeData) => {
    if (!probeData.tableRoot) {
      return () => ({ done: false, stabilityKey: null });
    }

    const { tableRoot, entryId, fieldId } = probeData;

    return () => getCellInlineEditorOpenFrameState(tableRoot, entryId, fieldId);
  },
  buildMetadata: () => {
    return {
      interactionTimingSource: 'dom-cell-inline-editor-open'
    };
  }
});
